import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { getSlides } from '../grapql/slides';

@Injectable({
  providedIn: 'root'
})
export class SlidesService {
  private url = environment.api;

  constructor(private http: HttpClient) { }
  getSlides(): Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getSlides()}).pipe(
      map((res: any) => {
        return res.data;
      })
    );
  }
}
